import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Две-три кнопки одной строкой, одинаковой высоты.
 *
 * Вкуишный ButtonGroup выравнивает детей по центру, а не тянет их по высоте:
 * подпись, не влезшая в одну строку, делала свою кнопку на восемь пикселей
 * выше соседней — проверено в браузере на «скопировать анкету» рядом с
 * «профиль игрока», 44 против 36. Здесь высоту задаёт самая высокая, и ряд
 * остаётся рядом.
 */
export function ActionRow({ children }: { children: ReactNode }) {
  return <div className={styles.actionRow}>{children}</div>;
}
